import { Controller, useFormContext } from 'react-hook-form'

import { CurrencyCentInput, FF2, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

type ReturnedCheckOutProps = {
  index: number
}

export const ReturnedCheckOut = ({ index }: ReturnedCheckOutProps) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`transactionsInfo.${index as 0}.returnedChecksOut`}
      control={control}
      rules={{ validate: (value) => Validators.required.notEmpty(value) }}
      render={({ field }) => (
        <FF2 required field={field} label="Returned Checks Out" input={(props) => <CurrencyCentInput {...props} />} />
      )}
    />
  )
}
